import React from "react"

type Props = {
     classNames?: string
     size?: "sm" | "md" | "lg" | "xl"
     text?: string
}

const MySimpleSpinner: React.FC<Props> = ({ classNames = "", size = "md", text }) => {
     // Default sizes
     let widthAndHeight = 2
     let textSizeClass = "fs-6"

     switch (size) {
          case "sm":
               widthAndHeight = 1.2 // Adjusted slightly for better text alignment (was 1.4)
               textSizeClass = "fs-7"
               break
          case "md":
               widthAndHeight = 2
               textSizeClass = "fs-6"
               break
          case "lg":
               widthAndHeight = 2.5
               textSizeClass = "fs-5"
               break
          case "xl":
               widthAndHeight = 3.5
               textSizeClass = "fs-4"
               break
     }

     return (
          <div className={`d-inline-flex align-items-center ${classNames}`}>
               <span
                    className="spinner-border align-middle"
                    style={{
                         width: `${widthAndHeight}rem`,
                         height: `${widthAndHeight}rem`,
                         borderWidth: size === "sm" ? "0.15em" : undefined, // Thinner border for small size
                    }}
                    role="status"
               >
                    <span className="visually-hidden">Loading...</span>
               </span>
               {text && <span className={`ms-2 fw-semibold ${textSizeClass}`}>{text}</span>}
          </div>
     )
}

export default MySimpleSpinner
